import React, { useRef } from 'react';
import Hero from "./components/Hero";
import Logos from "./components/Logos";
import Arweave from "./components/Arweave";
import Events from "./components/Events";
import Track from "./components/Track";
import Winner from './components/Winner';
import Ever from "./images/everfinance.png"
import Mem from "./images/mem-logo.svg"
import Forward from "./images/forward.jpg"
import PermawebNews from "./images/permawebnews.png"
import Arconnect from "./images/arconnect.png"
import ArweaveKit from "./images/arweavekit.png"
import UDL from "./images/udl.png"
import Navbar from './components/Navbar';

const winners = {

  zod: {
    title: 'Zod',
    author: 'Joel Mugalu',
    videoId: '34NHVv5u4cA',
    desc: 'A mobile-first browser for the permaweb, with in-built support Arweave wallets and dApps. The project was built mainly with ArweaveKit and Warp Contracts.',
    prize: ['Top 3 finalist', 'ArweaveKit Integration'],
    moreinfo: 'https://github.com/codingknite/zod'
  },

  udlvideo: {
    title: 'UDL Video Renderer',
    author: 'Elliot Sayes',
    videoId: 'yMzg3Cw1oTo',
    icon: UDL,
    iconlink: "https://arwiki.wiki/#/en/Universal-Data-License-How-to-use-it",
    desc: 'A web component designed to easily render video content from Arweave. The renderer leverages the Universal Data License to only show the entire contents of the video if the user purchased a license based on the license fee',
    prize: ['Top 3 finalist','Best UDL Video Player Renderer', 'ArConnect integration', 'Best use of ArSeeding'],
    moreinfo: 'https://github.com/elliotsayes/udl-video-renderer'
  },
  omnitory: {
    title: 'ꙮmnitory',
    author: 'Kay Plößer',
    videoUrl: 'https://arweave.net/WqqBplRKIwrHfF6OY5cOzez3DQcA3uWxwU1Zyaf7UQ8',
    desc: 'A Bun/Elysia-based service that handles decentralized package registration and metadata with Arweave and a MEM namespace',
    prize: ['Top 3 finalist', 'Best use of MEM'],
    moreinfo: 'https://github.com/kay-is/omnitory'
  },
  imagesearch: {
    title: 'Decentralized Image Search',
    author: 'Scott Hendrix',
    loomCode: '<div style="position: relative; padding-bottom: 53.125%; height: 0;"><iframe src="https://www.loom.com/embed/9de16afd123448878bcf080b4185189c?sid=37c5a37d-7ff8-4bab-8e87-c2e34b3657a5" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>',
    icon: UDL,
    iconlink: '',
    desc: 'A search engine that allows users to enter text queries and find images stored on Arweave. The user\'s text query is encoded into a vector word embedding in order to identify the meaning and for finding results. The client app via a web worker analyzes the query embedding and makes an API call and finds the granular categories closest to the search query.',
    prize: ['Best Search for the Permaweb'],
    moreinfo: 'https://github.com/scottroot/decentralized-image-search-app'
  },
  
  arweave101: {
    title: 'Arweave 101',
    author: 'Merdi Kim',
    loomCode: '<div style="position: relative; padding-bottom: 62.5%; height: 0;"><iframe src="https://www.loom.com/embed/46cd6408565848088850655394b57473?sid=4629f5dd-efca-4902-aefb-776fa43f7111" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>',
    desc: 'A 101 video designed to help new people understand Arweave, from the protocol to the tools and applications in the ecosystem.',
    prize: ['Best educational video content'],
    moreinfo: 'https://www.loom.com/share/46cd6408565848088850655394b57473?sid=c49008b5-fbc4-47a0-9e7d-49e8cc00ef5f'
  }
}

const tracks = {

  ever: {
    title: 'Best use of Arseeding',
    icon: Ever,
    iconlink: "https://ever.vision",
    desc: 'Use the everVision data availability service in your submission to qualify',
    prize: '$1,000',
    moreinfo: 'https://web3infra.dev/docs/arseeding/introduction/lightNode'
  },
  mem: {
    title: 'Best use of MEM',
    icon: Mem,
    iconlink: "https://mem.tech",
    desc: 'Use the Molecular Execution Machine (MEM) as your dApp\'s backend to qualify',
    prize: '$1,000',
    moreinfo: 'https://docs.mem.tech'
  },
  pwn: {
    title: 'Educational video content',
    icon: PermawebNews,
    iconlink: "https://permaweb.news",
    desc: 'Create a technology-focused video series for Arweave developers or end users.',
    prize: "$1,000",
    moreinfo: ''
  },
  fwdvideo: {
    title: 'UDL Video Player Renderer',
    icon: Forward,
    iconlink: "https://fwd.arweave.dev",
    desc: 'Create a renderer for video media that uses the UDL in order for users to view the entire video content.',
    prize: "$1,500",
    moreinfo: 'https://docs.google.com/document/d/1zlku_YzX7NArjG13tGnP-2aihWnnXbdbM0czWAynka8/edit?usp=sharing'
  },
  fwdsearch: {
    title: 'Search for the Permaweb',
    icon: Forward,
    iconlink: "https://fwd.arweave.dev",
    desc: 'Create a search engine based on discoverability and human curation for the Permaweb using Discoverability (ANS-110), STAMP, and Renderers.',
    prize: "$3,500",
    moreinfo: 'https://docs.google.com/document/d/1lbPc_hr_2wLjp3CoM-aZApBgCOVKVcoaZxC-5CbcOGQ/edit?usp=sharing'
  },
  arweaveKitIntegration: {
    title: 'ArweaveKit Integration',
    icon: ArweaveKit,
    iconlink: 'https://www.arweavekit.com/',
    prize: '$1,000',
    desc: 'Must use ArweaveKit as the primary tool in developing your application on Arweave. Use the kit as much as you can and showcase how you’ve used it. Those that create functional apps which fully integrate ArweaveKit will be considered for the bounty. Code must be hosted on protocol.land.',
    moreinfo: 'https://docs.arweavekit.com/arweavekit/introduction'
  },
  bestPluginSubmission: {
    title: 'Best plugin submission to ArweaveKit',
    icon: ArweaveKit,
    iconlink: 'https://www.arweavekit.com/',
    prize: '$1,000',
    desc: 'The plugin system streamlines the coding process by allowing developers the ability to leverage external packages from a variety of Arweave projects without needing direct integrations. All it takes is less than 5 lines of code to import a supported external package. This bounty will be awarded to the best plugin submission to ArweaveKit. Looking for plugins with the most utility, creativity, and impact. Code must be hosted on protocol.land.',
    moreinfo: 'https://docs.arweavekit.com/arweavekit/introduction'
  },
  arConnectIntegration: {
    title: 'ArConnect Integration',
    icon: Arconnect,
    iconlink: 'https://arconnect.io',
    prize: '$1,000',
    desc: 'Best project using ArConnect. Must directly use ArConnect to be considered for this bounty. Fully functional integration of Arconnect tied to an app that works. We’ll be looking for creative implementations that make the wallet experience better overall. Code must be hosted on protocol.land.',
    moreinfo: 'https://docs.arconnect.io/'
  }
}

function App() {
  const tracksRef = useRef();

  return (
    <div className="bg-gray-900">
      <Navbar />
      <Hero tracksRef={tracksRef} />
      <Arweave />
      <Logos />

      <div ref={tracksRef} class="mx-auto max-w-4xl text-center mt-8 py-6">
        <h1
          class="mb-5 bg-[#FF630B] bg-clip-text text-4xl font-extrabold text-transparent sm:text-4xl"
        >
          Winners
        </h1>
      </div>
      <div className="grid grid-cols-1 gap-10 pb-8 px-8">
        <Winner content={winners.zod} />
        <Winner content={winners.udlvideo} />
        <Winner content={winners.omnitory} />
        <Winner content={winners.imagesearch} />
        <Winner content={winners.arweave101} />
      </div>


      <div class="mx-auto max-w-4xl text-center mt-8 py-6">
        <h1
          class="mb-5 bg-[#FF630B] bg-clip-text text-4xl font-extrabold text-transparent sm:text-4xl"
        >
          Bounties
        </h1>
      </div>
      <div className="grid grid-cols-1 gap-10 pb-8 px-8">
        <Track content={tracks.ever} />
        <Track content={tracks.mem} />
        <Track content={tracks.fwdvideo} />
        <Track content={tracks.fwdsearch} />
        <Track content={tracks.arweaveKitIntegration} />
        <Track content={tracks.bestPluginSubmission} />
        <Track content={tracks.arConnectIntegration} />
        <Track content={tracks.pwn} />
      </div>
      <Events />
    </div>
  );
}

export default App;
